export const extractImageSrc = (htmlString: string | undefined): string | null => {
  const match = htmlString?.match(/<img[^>]+src=["'](.*?)["']/);

  return match ? match[1] : null;
};
